import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export interface StepStateViewModel {
  stepNumber: number;
  stepCount: number;
  hasPrevious: boolean;
  hasNext: boolean;
  readonly: boolean;
}

@Component({
    selector: 'app-step-header',
    templateUrl: './step-header.component.html',
    styleUrls: ['./step-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepHeaderComponent {
  readonly title = input<string>();
  readonly description = input<string>();
  readonly state = input<StepStateViewModel>();
}
